var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.2655C12.4031 5.80853 12.9358 5.48513 13.5272 5.33835C14.1186 5.19156 14.7406 5.22834 15.3106 5.4438C15.8806 5.65926 16.3714 6.04318 16.7179 6.54447C17.0643 7.04576 17.2498 7.64066 17.2498 8.25C17.2498 8.85934 17.0643 9.45424 16.7179 9.95553C16.3714 10.4568 15.8806 10.8407 15.3106 11.0562C14.7406 11.2717 14.1186 11.3084 13.5272 11.1617C12.9358 11.0149 12.4031 10.6915 12 10.2345M14.25 18.75H5.25V18C5.25 16.8065 5.72411 15.6619 6.56802 14.818C7.41193 13.9741 8.55653 13.5 9.75 13.5C10.9435 13.5 12.0881 13.9741 12.932 14.818C13.7759 15.6619 14.25 16.8065 14.25 18V18.75ZM14.25 18.75H18.75V18C18.7501 17.21 18.5423 16.434 18.1474 15.7498C17.7524 15.0656 17.1844 14.4974 16.5003 14.1024C15.8162 13.7074 15.0401 13.4994 14.2502 13.4994C13.4602 13.4993 12.6841 13.7073 12 14.1023M12.75 8.25C12.75 9.04565 12.4339 9.80871 11.8713 10.3713C11.3087 10.9339 10.5456 11.25 9.75 11.25C8.95435 11.25 8.19129 10.9339 7.62868 10.3713C7.06607 9.80871 6.75 9.04565 6.75 8.25C6.75 7.45435 7.06607 6.69129 7.62868 6.12868C8.19129 5.56607 8.95435 5.25 9.75 5.25C10.5456 5.25 11.3087 5.56607 11.8713 6.12868C12.4339 6.69129 12.75 7.45435 12.75 8.25Z",
    stroke: "#3F3F46",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/Users.a5c6c4c5400a60021d7bd8ab9aae86e5.svg";
export { ForwardRef as ReactComponent };